<header-row [userName]="'Victoria Brown'" [userRole]="'REGIONAL MANAGER'"></header-row>

<div class="ops-dashboard page-layout">
  <div class="dashboard-header">
    <div class="hospital-title">
      <div class="back" (click)="locationBack()">
        <span class="material-icons">arrow_back</span>
      </div>
      <h1 class="page-title">Dashboard</h1>
    </div>
    <div class="header-controls">
      <div class="select-wrap-qtr">
        <select class="quarter-select" [(ngModel)]="selectedQuarter" (ngModelChange)="applyQtr(quarterList)">
          <option value="default">Filter by Quarter</option>
          <option *ngFor="let quarter of quarterList" [value]="quarter.quarterName">
            {{ quarter.quarterName }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="main-section">
    <div class="card hospital-performance">

      <div class="performance-content" *ngIf="!isLoadingPerformance; else performanceLoader">
        <!-- OPS Score Section -->
        <div class="ops-score-section">
          <div class="ops-main">
            <div class="ops-label">
              <span>Overall Performance</span>
              <span>Score (OPS)</span>
            </div>
            <div class="ops-value">{{ OverallPerformance?.ops }}%</div>
            <!-- <div class="ops-change positive">+6% since last</div> -->
          </div>


        </div>

        <!-- Goals Progress Bars -->
         <div class="goals-wrap" *ngIf="dashboardDataList && dashboardDataList.length > 0">
        <div  class="goals-section" *ngFor="let goal of goalOps">
          <div class="risk-title">{{ goal.goalName || 'Revenue at Risk' }}</div>

          <div class="risk-segmented-bar">
            <div class="risk-segment on-track"
              [style.width]="(goal?.statusPercent?.ON_TRACK || 0) + '%'"
              [pTooltip]="'On Track: ' + (goal?.statusPercent?.ON_TRACK || 0) + '%'"
              pTooltipPosition="above">
              {{ goal?.statusPercent?.ON_TRACK || 0 }}%
            </div>
            <div class="risk-segment at-risk"
              [style.width]="(goal?.statusPercent?.AT_RISK || 0) + '%'"
              [pTooltip]="'At Risk: ' + (goal?.statusPercent?.AT_RISK || 0) + '%'"
              pTooltipPosition="above">
              {{ goal?.statusPercent?.AT_RISK || 0 }}%
            </div>
            <div class="risk-segment off-track"
              [style.width]="(goal?.statusPercent?.OFF_TRACK || 0) + '%'"
              [pTooltip]="'Off Track: ' + (goal?.statusPercent?.OFF_TRACK || 0) + '%'"
              pTooltipPosition="above">
              {{ goal?.statusPercent?.OFF_TRACK || 0 }}%
            </div>
          </div>
        </div>
      </div>
      </div>
      <ng-template #performanceLoader>
        <div class="section-loader">
          <div class="simple-spinner"></div>
          <span class="section-loader-text">Loading performance data...</span>
        </div>
      </ng-template>

      <!-- KPI Summary Row -->
      <!-- <div class="kpi-summary">
        <h3 class="kpi-title">KPI Summary</h3>
        <div class="metrics-row">
          <div class="metric-item">
            <div class="metric-label">Omni Revenue</div>
            <div class="metric-value">$275.6K</div>
            <div class="metric-change negative">▼1% vs prev</div>
          </div>
          <div class="metric-item">
            <div class="metric-label">Service Visits <span class="sub">(SV)</span></div>
            <div class="metric-value">888</div>
            <div class="metric-change negative">▼3% vs prev</div>
          </div>
          <div class="metric-item">
            <div class="metric-label">DVM Days <span class="sub">(DD)</span></div>
            <div class="metric-value">79</div>
            <div class="metric-change positive">▲5% vs prev</div>
          </div>
          <div class="metric-item">
            <div class="metric-label">SV / DD</div>
            <div class="metric-value">11.2</div>
            <div class="metric-change negative">▼8% vs prev</div>
          </div>
          <div class="metric-item">
            <div class="metric-label">Omni Rev / OV</div>
            <div class="metric-value">$168</div>
            <div class="metric-change positive">▲4% vs prev</div>
          </div>
        </div>
      </div> -->

      <!-- <div class="data-period">Data Last Refreshed: 01/10/2025</div> -->
    </div>

    <!-- Right Side: Two Stacked Boxes -->
    <div class="side-boxes">
      <!-- Upcoming Meetings -->
      <div class="card upcoming-meetings">
        <div class="card-header meetings-header">
          <h2 class="card-title">Scheduled Meetings</h2>
          <div class="header-actions">
            <button (click)="newAddMeetingPage()" class="icon-btn" type="button">
              <span class="material-icons">add</span>
            </button>
            <button class="icon-btn" type="button" (click)="openAddMeetingPage()">
              <span class="material-icons">calendar_today</span>
            </button>
          </div>
        </div>

        <div class="meetings-content" *ngIf="!isLoadingMeetings; else meetingsLoader">
          <div class="next-meeting-card" *ngIf="nextMeeting; else noMeetings">
            <div class="next-meeting-main" (click)="openMeetingDetailDialog(nextMeeting)">
              <div class="next-meeting-title">
                <span class="label">Next Meeting:</span>
                <span class="title">{{ nextMeeting.meetingSubject }}</span>
                <span *ngIf="nextMeeting.isRecurring" class="material-icons" style="font-size: 16px; color: #2e7d32; margin-left: 6px;" title="Recurring meeting">repeat</span>
              </div>

              <div class="next-meeting-meta">
                <div class="meta-block">
                  <span class="meta-label">Location</span>
                  <span class="meta-value">{{ nextMeeting.hospitalName || '—' }}</span>
                </div>
                <div class="meta-block">
                  <span class="meta-label">Duration</span>
                  <span class="meta-value">{{ nextMeeting.duration || '—' }}</span>
                </div>
              </div>

              <div class="next-meeting-time">
                <span class="material-icons">schedule</span>
                {{ nextMeeting.startTime }} - {{ nextMeeting.endTime }} ({{ nextMeeting.timeZone }})
              </div>
              <div class="next-meeting-date">
                <span class="material-icons">calendar_today</span>
                {{ nextMeeting.scheduledDate | date:'MM/dd/yyyy' }}
              </div>
            </div>

            <button class="join-btn" (click)="joinMeeting(nextMeeting.joinUrl)">
              <span class="material-icons">videocam</span>
              Join
            </button>
          </div>

          <p-accordion *ngIf="remainingMeetings && remainingMeetings.length > 0"
            class="meetings-accordion" [multiple]="true" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
            <p-accordionTab header="Upcoming Meetings">
              <div class="meeting-grid">
                <div class="meeting-item" *ngFor="let meeting of remainingMeetings">
                  <div class="meeting-details" (click)="openMeetingDetailDialog(meeting)">
                    <div class="meeting-title">
                      {{ meeting.meetingSubject }}
                      <span *ngIf="meeting.isRecurring" class="material-icons" style="font-size: 14px; color: #2e7d32; margin-left: 4px;" title="Recurring meeting">repeat</span>
                    </div>
                    <div class="meeting-date">
                      <span class="material-icons">calendar_today</span>
                      {{ meeting.scheduledDate | date:'MM/dd/yyyy' }}
                    </div>
                    <div class="meeting-time">
                      <span class="material-icons">schedule</span>
                      {{ meeting.startTime }} - {{ meeting.endTime }} ({{ meeting.timeZone }})
                    </div>
                  </div>

                  <button class="join-btn" (click)="joinMeeting(meeting.joinUrl)">
                    <span class="material-icons">videocam</span>
                    Join
                  </button>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>

          <ng-template #noMeetings>
            <div class="empty-state">No meetings found for today.</div>
          </ng-template>
        </div>
        <ng-template #meetingsLoader>
          <div class="section-loader">
            <div class="simple-spinner"></div>
            <span class="section-loader-text">Loading meetings...</span>
          </div>
        </ng-template>
      </div>

      <!-- Updates & Tasks -->
      <div class="card updates-tasks">
        <div class="card-header tasks-header">
          <h2 class="card-title">Tasks</h2>
          <div class="header-actions">
            <button class="icon-btn" type="button" (click)="createNewtask()">
              <span class="material-icons">add</span>
            </button>
            <button class="icon-btn" type="button" (click)="taskListPage()">
              <span class="material-icons">assignment</span>
            </button>
          </div>
        </div>

        <div class="tasks-content" *ngIf="!isLoadingTasks; else tasksLoader">
          <p-accordion class="tasks-accordion" [multiple]="true" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">

            <!-- Past Due Tasks Section -->
            <p-accordionTab [header]="'Past Due (' + pastDueTasks.length + ')'" *ngIf="pastDueTasks.length > 0"
              [attr.title]="'Shows only the 3 most delinquent tasks. Click See More to view additional.'">
              <ng-template pTemplate="header">
                <span class="task-header-label">Past Due</span>
                <span class="task-count-badge past-due">{{ pastDueTasks.length }}</span>
              </ng-template>
              <div class="task-list">
                <div class="task-item" *ngFor="let task of pastDueTasks | slice:0:3">
                  <div class="task-info" (click)="openViewTask(task.taskId, 'tasks')">
                    <div class="task-name">{{ task.task | titlecase}}</div>
                    <div class="task-meta">
                      Due Date - {{ task.dueDate | date: 'MM/dd/yyyy' }} | Assigned To - {{ task.assignedTo }}
                    </div>
                  </div>
                </div>
                <div *ngIf="pastDueTasks.length > 3" class="see-more-accordion" (click)="taskListPage()">
                  <span class="see-more-label">See More</span>
                </div>
              </div>
            </p-accordionTab>

            <!-- Upcoming Tasks Section -->
            <p-accordionTab header="Upcoming Tasks ({{ upcomingTasks.length }})" *ngIf="upcomingTasks.length > 0"
              [title]="'Next 3 tasks due within 3 days. Click See More to view additional.'">
              <ng-template pTemplate="header">
                <span class="task-header-label">Upcoming Tasks</span>
                <span class="task-count-badge upcoming">{{ upcomingTasks.length }}</span>
              </ng-template>
              <div class="task-list">
                <div class="task-item" *ngFor="let task of (upcomingTasks | slice:0:3)">
                  <div class="task-info" (click)="openViewTask(task.taskId, 'tasks')">
                    <div class="task-name">{{ task.task | titlecase}}</div>
                    <div class="task-meta">
                      Due Date - {{ task.dueDate | date: 'MM/dd/yyyy' }} | Hospital Name - {{ task.hospitalName || 'none' }} | Assigned To - {{ task.assignedTo || 'none' }}
                    </div>
                  </div>
                </div>
                <div *ngIf="(upcomingTasks).length > 3" class="see-more-accordion" (click)="taskListPage()">
                  <span class="see-more-label">See More</span>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>

          <div *ngIf="pastDueTasks.length === 0 && upcomingTasks.length === 0" class="empty-state">
            No tasks found for this quarter.
          </div>
        </div>
        <ng-template #tasksLoader>
          <div class="section-loader">
            <div class="simple-spinner"></div>
            <span class="section-loader-text">Loading tasks...</span>
          </div>
        </ng-template>

      </div>
    </div>
  </div>

  <!-- Hospital Status Overview -->
  <div>
    <div class="wrappertable hospital-status">
      <div *ngIf="dashboardDataList && dashboardDataList.length > 0; else nogoal">
      <div class="status-header">
        <h2 class="card-title">Hospital Status Overview</h2>
        <div class="status-filters">
          <p-multiSelect
            [options]="uniqueHospitalNames"
            [(ngModel)]="filterHospitals"
            placeholder="Filter by Hospital"
            (onChange)="applyTableFilters()"
            [showClear]="true"
            [filter]="true"
            [maxSelectedLabels]="1"
            selectedItemsLabel="{0} hospitals selected"
            appendTo="body"></p-multiSelect>
          <p-multiSelect
            [options]="uniqueRMNames"
            [(ngModel)]="filterRMs"
            placeholder="Filter by Regional Manager"
            (onChange)="applyTableFilters()"
            [showClear]="true"
            [filter]="true"
            [maxSelectedLabels]="1"
            selectedItemsLabel="{0} managers selected"
            appendTo="body"></p-multiSelect>
          <p-multiSelect
            [options]="uniqueGoalNames"
            [(ngModel)]="filterGoals"
            placeholder="Filter by Goal"
            (onChange)="applyTableFilters()"
            [showClear]="true"
            [filter]="true"
            [maxSelectedLabels]="1"
            selectedItemsLabel="{0} goals selected"
            appendTo="body"></p-multiSelect>
          <p-multiSelect
            [options]="leadershipFilterOptions"
            optionLabel="label"
            optionValue="key"
            [(ngModel)]="filterLeadershipAttentionRequiredList"
            placeholder="Filter by Leadership Attention"
            (onChange)="applyTableFilters()"
            [showClear]="true"
            [filter]="true"
            [maxSelectedLabels]="1"
            selectedItemsLabel="{0} selected"
            appendTo="body"></p-multiSelect>
          <button
            class="view-all-btn"
            type="button"
            [class.active]="priorityPracticeOnly"
            (click)="togglePriorityPracticeFilter()">
            <span class="material-icons">{{ priorityPracticeOnly ? "star" : "star_border" }}</span>
            Priority Practice
          </button>
          <button class="view-all-btn" (click)="resetTableFilters()">Reset</button>

        </div>
      </div>

      <div class="table-scroll">
      <table class="hospital-table responsive-table">
        <thead>
          <tr>
            <th>Action</th>
            <th (click)="sortBy('hospitalName')" style="cursor:pointer">Hospital <span class="sort-icon">{{
                getSortIcon('hospitalName') }}</span></th>
            <th (click)="sortBy('rmName')" style="cursor:pointer">Regional Manager <span class="sort-icon">{{
                getSortIcon('rmName') }}</span></th>
            <th (click)="sortBy('opsScore')" style="cursor:pointer">OPS Score <mat-icon
                class="info-icon"  [pTooltip]="'OPS\n\nWhat it shows:\nOverall performance score for the selected period, expressed as a 0–100% composite.\n\nHow to interpret:\nRolls up all active goals based on their weighted performance vs target.\nHigher OPS = stronger aggregate execution against plan.\nOPS is a point-in-time score, not a trend indicator.'">info</mat-icon>
              <span class="sort-icon">{{ getSortIcon('opsScore') }}</span>
            </th>
            <th (click)="sortBy('status')" style="cursor:pointer">Status <mat-icon class="info-icon" [pTooltip]="'Status\n\nWhat it shows:\nWhether goals are currently On Track, At Risk, or Off Track.\n\nHow to interpret:\nDetermined by current Pace relative to where the goal should be at this point in the quarter.\nStatus answers: “Are we where we should be right now?”'">info</mat-icon>
              <span class="sort-icon">{{ getSortIcon('status') }}</span>
            </th>
            <th (click)="sortBy('momentum')" style="cursor:pointer">Momentum <mat-icon class="info-icon" [pTooltip]="'Momentum\n\nWhat it shows:\nDirection of performance change.\n\nHow to interpret:\nMeasures short-term trend (e.g., week-over-week or last 4 weeks).\nPositive Momentum = improving pace.\nNegative Momentum = declining pace.\nMomentum answers: “Are we getting better or worse?”'">info</mat-icon>
              <span class="sort-icon">{{ getSortIcon('momentum') }}</span>
            </th>
            <th (click)="sortBy('l13WRevenue')" style="cursor:pointer">L13W Revenue <span class="sort-icon">{{
                getSortIcon('l13WRevenue') }}</span></th>
            <th (click)="sortBy('revenueWeight')" style="cursor:pointer">L13W Revenue Wt <span class="sort-icon">{{
                getSortIcon('revenueWeight') }}</span></th>
            <th>Upcoming Goal Health <mat-icon class="info-icon " >info</mat-icon></th>
            <th>Task Health <mat-icon class="info-icon" [pTooltip]="'Task Health\n\nWhat it shows:\nSummarizes execution readiness by showing overdue tasks relative to total active tasks tied to active goals.\n\nHow to interpret:\nShows Past Due Tasks / Total Open Tasks\n0 / X = work is being completed on time.\n>0 / X = operational slippage risk.'">info</mat-icon></th>
            <th>Next Meeting</th>
            <th>Execution Health <mat-icon class="info-icon" [pTooltip]="'Execution Health\n\nWhat it shows:\nOverall execution stability across goals.\n\nHow to interpret:\nIncorporates stalled goals, excessive overdue tasks, bottlenecks (e.g., waiting on VP > threshold), and lack of activity.\nExecution Health answers: “Is the system moving, or stuck?”'">info</mat-icon></th>
            <th>RM Attention Required</th>
            <th>Leadership Attention Required</th>
            <!-- <th>Issue Driver</th> -->
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let hospital of pagedData">
            <tr class="expandable" (click)="toggleRow(hospital.hospitalId)">
              <td class="hospital-name">
                <span class="expand-icon">
                  <span class="material-icons">{{ isRowExpanded(hospital.hospitalId) ? 'remove' : 'add' }}</span>
                </span>
              </td>
              <!-- (click)="openHospitalEditerPage(hospital.hospitalId)" -->
              <td class="clickable-link" (click)="openHospitalOpsDashboard(hospital.hospitalId, $event)">
                {{ hospital.hospitalName }}
              </td>
              <td>{{ hospital.rmName }}</td>
              <td>
                <div *ngIf="getEffectiveOpsScore(hospital) !== null" class="progress-cell">
                  <span class="progress-value ops-score-highlight">{{ getEffectiveOpsScore(hospital) | number:'1.0-1' }}%</span>
                  <div class="progress-bar-inline">
                    <div class="progress-fill ops-score-bar"
                      [style.width]="(getEffectiveOpsScore(hospital) > 100 ? 100 : getEffectiveOpsScore(hospital)) + '%'"></div>
                  </div>
                </div>
                <span *ngIf="getEffectiveOpsScore(hospital) === null" class="no-data-text">No Data</span>
              </td>
              <td>
                <span *ngIf="getEffectiveStatus(hospital) && getEffectiveStatus(hospital) !== 'NoData'" class="status-badge" [ngClass]="getEffectiveStatus(hospital)">
                  <span class="status-dot"></span>{{ getStatusLabel(getEffectiveStatus(hospital)) }}
                </span>
                <span *ngIf="!getEffectiveStatus(hospital) || getEffectiveStatus(hospital) === 'NoData'" class="no-data-text">No Data</span>
              </td>
              <td>
                <span *ngIf="!isOnTrackStatus(getEffectiveStatus(hospital)) && getEffectiveMomentum(hospital) !== null" class="momentum-badge"
                  [ngClass]="getEffectiveMomentum(hospital) === 'FLAT' ? 'flat' : (getEffectiveMomentum(hospital) === 'DECLINING' ? 'declining' : 'improving')">
                  <span class="momentum-icon">
                    <span class="material-icons">
                      {{ getEffectiveMomentum(hospital) === 'FLAT' ? 'remove' : (getEffectiveMomentum(hospital) === 'DECLINING' ? 'arrow_downward'
                      :
                      'arrow_upward') }}
                    </span>
                  </span>
                  {{ getEffectiveMomentum(hospital) === 'FLAT' ? 'Flat' : (getEffectiveMomentum(hospital) === 'DECLINING' ? 'Declining' :
                  'Improving') }}
                </span>
                <span *ngIf="isOnTrackStatus(getEffectiveStatus(hospital)) || getEffectiveMomentum(hospital) === null">—</span>

              </td>

              <td>{{ hospital.l13WRevenue != null && hospital.l13WRevenue !== '' ? (hospital.l13WRevenue | currency) :
                '-'
                }}</td>
              <td>{{ hospital.revenueWeight != null && hospital.revenueWeight !== '' ? hospital.revenueWeight + '%' :
                '-'
                }}</td>

              <td>{{ getTotalStaleGoals(getEffectiveGoals(hospital)) }} / {{ getTotalPendingGoals(getEffectiveGoals(hospital)) }}</td>

              <td>
                <div *ngIf="getHospitalTaskInfos(getEffectiveGoals(hospital)).length > 0"
                     class="task-summary"
                     (click)="$event.stopPropagation(); openViewTask(getHospitalTaskInfos(getEffectiveGoals(hospital)), 'goals')">
                  <span class="material-icons">visibility</span>
                  <div class="task-summary-text">
                    <div class="task-summary-line">
                      <span class="task-summary-count">{{ getTotalCompletedTaskCount(getEffectiveGoals(hospital)) }}</span> Complete
                    </div>
                    <div class="task-summary-line">
                      <span class="task-summary-count">{{ getTotalAssignedTaskCount(getEffectiveGoals(hospital)) }}</span> Total
                    </div>
                  </div>
                </div>
                <span *ngIf="getHospitalTaskInfos(getEffectiveGoals(hospital)).length === 0">
                  {{ getTotalCompletedTaskCount(getEffectiveGoals(hospital)) }} / {{ getTotalAssignedTaskCount(getEffectiveGoals(hospital)) }}
                </span>
              </td>
              <td>
                <small>{{ hospital.nextMeetingDate ? (hospital.nextMeetingDate | date:'MM/dd/yyyy') : '-' }}</small>
                 <small>{{ hospital.nextMeetingStartTime ? (hospital.nextMeetingStartTime ) : '-' }}</small>
              </td>
              <td>
                <span class="execution-health" [ngClass]="getExecutionHealthClass(getEffectiveExecutionHealth(hospital))">{{
                  getExecutionHealthLabel(getEffectiveExecutionHealth(hospital)) }}   </span>
              </td>
              <td>
                <span class="rm-attention-required"
                  [ngClass]="getRmAttentionRequiredClass(hospital.rmAttentionRequired)">
                  {{ getRmAttentionRequiredLabel(hospital.rmAttentionRequired) }}
                </span>
              </td>
              <td>
                <span class="leadership-attention-required"
                  [ngClass]="getLeadershipAttentionClass(hospital.leadershipAttentionRequired)">
                  {{ getLeadershipAttentionLabel(hospital.leadershipAttentionRequired) }}
                </span>
              </td>
              <!-- <td>
                <span *ngIf="hospital.issueDriver" class="issue-driver"
                  [ngClass]="getIssueDriverClass(hospital.issueDriver)">
                  {{ getIssueDriverLabel(hospital.issueDriver) }}
                </span>
                <span *ngIf="!hospital.issueDriver">—</span>
              </td> -->
            </tr>
            <tr *ngIf="isRowExpanded(hospital.hospitalId)" class="expanded-content">
              <td colspan="14">
                <div class="goal-details">
                  <table class="goals-table">
                    <thead>
                      <tr>
                        <th>Goal</th>
                        <th>OPS Score</th>
                        <th>Pace</th>
                        <th>Status</th>
                        <th>Momentum</th>
                        <th>Task Health</th>
                        <th>Execution Health</th>
                        <!-- <th>Issue Driver</th> -->
                        <th>Notes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let goal of getFilteredHospitalGoals(hospital)">
                        <td>{{ goal.goalName }}</td>
                        <td>
                          <div *ngIf="goal.opsScore !== null" class="progress-cell">
                            <span class="progress-value ops-score-highlight">{{ goal.opsScore | number:'1.0-1'}}%</span>
                            <div class="progress-bar-inline">
                              <div class="progress-fill ops-score-bar"
                                [style.width]="(goal.opsScore > 100 ? 100 : goal.opsScore) + '%'"></div>
                            </div>
                          </div>
                          <span *ngIf="goal.opsScore === null" class="no-data-text">No Data</span>
                        </td>
                        <td>
                          <div *ngIf="goal.pace !== null" class="progress-cell">
                            <span class="progress-value">{{ goal.pace * 100 | number:'1.0-0' }}%</span>
                            <div class="progress-bar-inline">
                              <div class="progress-fill"
                                [style.width]="(goal.pace * 100 > 100 ? 100 : goal.pace * 100) + '%'"></div>
                            </div>
                          </div>
                          <span *ngIf="goal.pace === null" class="no-data-text">No Data</span>
                        </td>
                        <td>
                          <span class="status-badge" [ngClass]="goal.status">
                            <span class="status-dot"></span>{{ getStatusLabel(goal.status) }}
                          </span>
                        </td>
                        <td>
                          <span *ngIf="!isOnTrackStatus(goal.status) && goal.momentum !== null" class="momentum-badge"
                            [ngClass]="goal.momentum === 'FLAT' ? 'flat' : (goal.momentum === 'DECLINING' ? 'declining' : 'improving')">
                            <span class="momentum-icon">
                              <span class="material-icons">{{ goal.momentum === 'FLAT' ? 'remove' : (goal.momentum ===
                                'DECLINING' ? 'arrow_downward' : 'arrow_upward') }}</span>
                            </span>
                            {{ goal.momentum === 'FLAT' ? 'Flat' : (goal.momentum === 'DECLINING' ? 'Declining' :
                            'Improving') }}
                          </span>
                          <span *ngIf="isOnTrackStatus(goal.status) || goal.momentum === null">—</span>
                        </td>
                        <td>
                          <div *ngIf="goal.taskCount === 0 && goal.taskComplete === 0" class="task-summary no-task"
                            (click)="$event.stopPropagation(); openCreateTask(goal, hospital)">
                            <span class="material-icons">visibility_off</span>
                            <div class="task-summary-text">
                              <div class="task-summary-line">No tasks</div>
                              <div class="task-summary-line">assigned</div>
                            </div>
                          </div>
                          <div *ngIf="goal.taskCount !== 0 || goal.taskComplete !== 0"
                               class="task-summary"
                               (click)="$event.stopPropagation(); openViewTask(goal.taskInfos, 'goals')">
                            <span class="material-icons">visibility</span>
                            <div class="task-summary-text">
                              <div class="task-summary-line">
                                <span class="task-summary-count">{{goal.taskComplete}}</span> Complete
                              </div>
                              <div class="task-summary-line">
                                <span class="task-summary-count">{{ goal.taskCount }}</span> Total
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span class="execution-health" [ngClass]="getExecutionHealthClass(goal.executionHealth)">{{
                            getExecutionHealthLabel(goal.executionHealth) }}</span>
                        </td>
                        <!-- <td>
                          <span *ngIf="goal.issueDriver" class="issue-driver"
                            [ngClass]="getIssueDriverClass(goal.issueDriver)">
                            {{ getIssueDriverLabel(goal.issueDriver) }}
                          </span>
                          <span *ngIf="!goal.issueDriver">—</span>
                        </td> -->
                        <td>
                          <button class="view-notes-btn" (click)="$event.stopPropagation(); viewGoalPage(goal)">
                            <span class="material-icons">visibility</span> View
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      </div>

      <!-- Pagination -->
      <div class="table-pagination">
        <span class="pagination-info">{{ paginationInfo }}</span>
        <div class="pagination-controls">
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
            <span class="material-icons">chevron_left</span>
          </button>
          <span class="page-numbers">
            <button *ngFor="let page of pageNumbers" class="page-btn" [class.active]="page === currentPage"
              (click)="goToPage(page)">{{ page }}</button>
          </span>
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
            <span class="material-icons">chevron_right</span>
          </button>
        </div>
      </div>
    </div>

    <ng-template #nogoal>
      <div class="empty-state"
        style="text-align:center; padding: 40px 20px; color:#4f4f4f;     border: 2px dotted #8080803d;">
        <div class="empty-icon"
          style="display:inline-flex; align-items:center; justify-content:center; width:72px; height:72px; border-radius:50%; background:#f1f5f9; margin-bottom:16px;">
          <span class="material-icons" style="color:#00ba9d; font-size:36px;">assignment</span>
        </div>
        <h4 style="margin: 0 0 8px; font-weight:600;">No Data found</h4>
        <p style="margin: 0 0 16px;">Try adjusting Quarter </p>
      </div>
    </ng-template>
    </div>
  </div>
</div>

<div *ngIf="isLoadingHospitals"
   style="display: flex; align-items: center; justify-content: center; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255, 255, 255, 0.95); z-index: 9999;">
   <div style="text-align: center;">
      <img src="/assets/catSpinner.gif" style="width:130px; margin-bottom: 20px;">
      <div style="color:#363636; font-size: 24px;">Loading dashboard...</div>
   </div>
</div>
